import api from "./Api";

class TecnicoEnderecoService {
  GetTecnicoEndereco(payload) {
    return api.get("/v1/tecnicoEndereco/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTecnicoEndereco(payload) {
    return api.post("/v1/tecnicoEndereco/", payload).then((response) => {
      return response.data;
    });
  }

  PutTecnicoEndereco(payload) {
    return api.put("/v1/tecnicoEndereco/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTecnicoEndereco(payload) {
    return api.delete("/v1/tecnicoEndereco/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTecnicoEnderecoOData(payload) {
    return api.get("/OData/TecnicoEndereco" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new TecnicoEnderecoService();
